import htmx from 'htmx.org';

declare global {
  interface Window {
    isDevMode: boolean;
    sentryOn: boolean;
    htmx: typeof htmx;
  }
}

window.htmx = htmx;
window.htmx.process(document.body);
